export function request(url, options){
    var method = options.method || 'get'
    var params = options.params || {}
    var data = options.data || {}
    var onSuccess = options.onSuccess
    var onError = options.onError 
    var xhr = new XMLHttpRequest()
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          onSuccess && onSuccess(xhr.responseText)
        } else {
          onError && onError(xhr.status)
        }
      }
    }
    url = method === 'get' ? url + '?' + dumps(params) : url;
    var body = method === 'get' ? null : dumps(data);
    xhr.open(method, url)
    xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded')
    xhr.send(body)
  }
  
  function dumps(obj) {
    var tmp = []
    for(var key in obj) {
      tmp.push(key + '=' + obj[key]);
    }
    return tmp.join('&')
  }